import { TError, TOnlineUsersResponseSchema } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';
import { WHO_IS_ONLINE_ENTITY } from './entity';
import { WHO_IS_ONLINE_QUERY_KEYS } from './use-get-all-online-users-query';

type TOptions = {
  enabled?: boolean;
  refetchInterval?: number;
};

/** Online users without private users. Open to every member — use `useGetAllOnlineUsersQuery` only in the dashboard. */
export const useGetPublicOnlineUsersQuery = (options: TOptions = {}) => {
  const { enabled, refetchInterval } = options;

  return useQuery<TOnlineUsersResponseSchema, TError>({
    queryKey: WHO_IS_ONLINE_QUERY_KEYS.publicUsers(),
    queryFn: async () => {
      const res = await axios.get<TOnlineUsersResponseSchema>(`/${WHO_IS_ONLINE_ENTITY}/public-users`);
      return res.data;
    },
    enabled: enabled ?? true,
    refetchInterval,
  });
};
